export { SELECTION_CHANGE, SelectionDirection, SelectionMode } from '@uifabric/utilities';
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/utilities/selection/interfaces.js
// module id = 66
// module chunks = 0